import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisV } from '@fortawesome/pro-solid-svg-icons';

import confirm from 'components/confirm';
import FormModal from './form_modal';
import { listItemPropTypes, reorderableListItem } from 'helpers/react_dnd/reorderable_list';
import { valueTypes } from './optional_liquid_input';
import OverrideControls from './override_controls';
import { optionPropTypes } from './option_prop_types';

export class OptionRow extends React.Component {
  static propTypes = {
    ...optionPropTypes,
    ...listItemPropTypes,

    inputsClassName: PropTypes.string,
    renderHiddenValue: PropTypes.func.isRequired,
    renderInputs: PropTypes.func.isRequired
  }

  state = {
    editing: false
  }

  showModal = (event) => {
    event.stopPropagation();
    this.setState({ editing: true });
  }

  hideModal = () => {
    this.setState({ editing: false });
  }

  handleOptionChange = (option) => {
    this.props.onOptionChange(option, this.props.index);
    this.setState({ editing: false });
  }

  handleOverrideDefault = () => {
    this.props.onOverrideDefault(this.props.option);
  }

  handleUseDefault = () => {
    this.props.onUseDefault(this.props.option);
  }

  deleteOption = (event) => {
    event.stopPropagation();
    confirm(`Delete ${this.props.option.label || this.props.option.id}?`, {
      buttonLabel: 'Delete',
      buttonStyle: 'danger',
      title: 'Delete option'
    }).then(() => {
      this.props.onOptionDelete(this.props.option, this.props.index);
    }).catch(() => {});
  }

  render() {
    const hidden = this.props.option.hidden.evaluated;
    if (hidden && !this.props.admin) {
      return null;
    }

    return this.props.connectDragPreview(this.props.connectDropTarget(
      <div className="email-option-wrapper" style={{ opacity: this.props.isDragging ? 0 : 1 }}>
        {this.renderDragHandle()}
        {this.renderRow(hidden)}
        {this.renderModal()}
      </div>
    ));
  }

  renderRow(hidden) {
    return (
      <div className="email-option" name="row-content">
        <div className="email-option-info">
          <div>
            <i className={`fa-solid fa-${this.props.option.icon.iconName} fa-lg fa-fw icon`} />
            {this.props.option.label}
          </div>

          {this.renderOverrideControls()}
        </div>


        <div className={classNames('email-option-inputs', this.props.inputsClassName, { disabled: hidden })}>
          {hidden ? this.props.renderHiddenValue() : this.props.renderInputs()}
        </div>

        {this.renderAdminDetails()}
      </div>
    );
  }

  renderDragHandle() {
    if (!this.props.admin) {
      return null;
    }

    return this.props.connectDragSource(
      <div className="drag-handle" name="drag-handle">
        <FontAwesomeIcon icon={faEllipsisV} />
      </div>
    );
  }

  renderModal() {
    if (!this.props.admin) {
      return null;
    }

    return (
      <FormModal
        index={this.props.index}
        liquidContext={this.props.liquidContext}
        option={this.props.option}
        options={this.props.options}
        show={this.state.editing}
        onCancel={this.hideModal}
        onOk={this.handleOptionChange}
      />
    );
  }

  renderAdminDetails() {
    if (!this.props.admin) {
      return null;
    }

    return (
      <div className="email-option-details">
        <span className="right-buffer-sm">
          Liquid ID: options.{this.props.option.id}
          {this.renderDefaultPreview()}
        </span>

        {this.renderAdminControls()}
      </div>
    );
  }

  renderDefaultPreview() {
    if (this.props.option.default.type != valueTypes.liquid) {
      return null;
    }

    let value = this.props.option.default.evaluated;
    if (this.props.option.multiselect) {
      value = Object.keys(value || {}).join(", ");
    } else {
      value = value.toString();
    }

    return <span name="default-preview">{' '}(default: {value})</span>;
  }

  renderAdminControls() {
    if (this.props.readOnlyOption) {
      return null;
    }

    return (
      <span className="email-option-controls">
        <span className="right-buffer-sm" name="edit" onClick={this.showModal}>Edit</span>
        <span name="delete" onClick={this.deleteOption}>Delete</span>
      </span>
    );
  }

  renderOverrideControls() {
    if (!this.props.overrideMode) {
      return null;
    }

    return (
      <OverrideControls
        overridden={this.props.overridden}
        onOverrideDefault={this.handleOverrideDefault}
        onUseDefault={this.handleUseDefault}
      />
    );
  }
}

export default reorderableListItem(OptionRow, 'optionRow', {
  beginDrag(props) {
    return {
      id: props.option.id,
      index: props.index
    };
  }
});
